import getAlignmentOptions from './alignment';
import getFontSizeOptions from './fontSize';
import getFontFamilyOptions from './fontFamily';

export { getAlignmentOptions, getFontSizeOptions, getFontFamilyOptions };
